import md5 from 'js-md5';
import addinstance from './instance.js'
import geturl from './seturl'
import axios from 'axios';
var qs = require('qs');
const instance = axios.create({
    baseURL:'https://test.migee.net/index.php/',
    // test
  
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [function (data) {
      data = qs.stringify(data);
      return data;
    }],
    withCredentials: true,
    crossDomain: true,
  });
//平台菜单
export const serviceindex= params=> {return addinstance().get(geturl(`/service/index`),{params:params});}
export const createservice= params => { return addinstance().post(geturl(`/service/create`), params) };
export const updateservice= params => { return addinstance().post(geturl(`/service/update`), params) };
export const createserviceimg= params => { return instance.post(geturl(`/common/component/upload`), params) };


// WEBPACK FOOTER //
// ./src/api/serviceapi.js